import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appPasswordValidation]',
  standalone: true,
})

export class PasswordValidationDirective {

  constructor() { }
}

export function passwordValidation(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value)
    {
      // password should contain at least 8 digits, 1 upppercase, 1 lowercase, 1 number, 1 non letter or digit (special char)
      let pwdRule: RegExp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/g);      
      let validPassword = pwdRule.test(control.value);
      return !validPassword ? {"invalidPassword": true} : null;
    }
    return null;
  };
}

export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = nameRe.test(control.value);
    return forbidden ? {'forbiddenName': {value: control.value}} : null;
  };
}
